// Data untuk Section About
import type { Language } from "@/lib/i18n";

interface AboutHomeData {
  tagline: string;
  title: string;
  description: string[];
  image: string;
  testimonial: {
    quote: string;
    author: string;
    role: string;
  };
  cta: {
    text: string;
    link: string;
  };
}

interface TeamMember {
  id: number;
  name: string;
  role: string;
  image: string;
  bio: string;
}

const aboutHomeDataByLang: Record<Language, AboutHomeData> = {
  id: {
    tagline: "Filosofi Kami",
    title: "Mendefinisikan Ulang Kemewahan\nStandar Baru Kost Elite.",
    description: [
      "KinKen Kost Elite hadir bukan sekadar sebagai tempat tinggal, melainkan sebagai katalisator gaya hidup urban yang canggih.",
      "Kami memadukan privasi hunian pribadi dengan layanan premium setara hotel, menciptakan ekosistem yang mendukung produktivitas dan kesejahteraan.",
    ],
    image: "/images/about/about-section.webp",
    testimonial: {
      quote:
        "Seperti tinggal di apartemen mewah dengan layanan hotel bintang 5.",
      author: "Michael Chen",
      role: "Tech Expat, Penghuni sejak 2023",
    },
    cta: {
      text: "Temukan Cerita Kami",
      link: "/about",
    },
  },
  en: {
    tagline: "Our Philosophy",
    title: "Redefining Luxury Living\nThe New Standard of Elite Co-Living.",
    description: [
      "KinKen Kost Elite is more than just accommodation—it's a catalyst for sophisticated urban living.",
      "We blend the privacy of personal residence with premium hotel-grade services, creating an ecosystem that supports both productivity and well-being.",
    ],
    image: "/images/about/about-section.webp",
    testimonial: {
      quote:
        "It's like living in a luxury apartment with 5-star hotel services.",
      author: "Michael Chen",
      role: "Tech Expat, Resident since 2023",
    },
    cta: {
      text: "Discover Our Story",
      link: "/about",
    },
  },
};

const teamMembersByLang: Record<Language, TeamMember[]> = {
  id: [
    {
      id: 1,
      name: "Andi Hermawan",
      role: "Founder & CEO",
      image: "/images/about/members/member-1.webp",
      bio: "Visioner dengan 15+ tahun pengalaman di industri perhotelan luxury.",
    },
    {
      id: 2,
      name: "Siti Rahmawati",
      role: "Head of Operations",
      image: "/images/about/members/member-2.webp",
      bio: "Memastikan standar kebersihan dan pelayanan operasional tetap prima.",
    },
    {
      id: 3,
      name: "Budi Santoso",
      role: "Concierge Manager",
      image: "/images/about/members/member-3.webp",
      bio: "Siap membantu kebutuhan personal penghuni 24/7 dengan senyuman ramah.",
    },
    {
      id: 4,
      name: "Jessica Tan",
      role: "Community Manager",
      image: "/images/about/members/member-4.webp",
      bio: "Menciptakan event dan suasana komunitas yang hangat antar penghuni.",
    },
  ],
  en: [
    {
      id: 1,
      name: "Andi Hermawan",
      role: "Founder & CEO",
      image: "/images/about/members/member-1.webp",
      bio: "Visionary with 15+ years of experience in the luxury hospitality industry.",
    },
    {
      id: 2,
      name: "Siti Rahmawati",
      role: "Head of Operations",
      image: "/images/about/members/member-2.webp",
      bio: "Ensuring cleanliness and operational service standards remain excellent.",
    },
    {
      id: 3,
      name: "Budi Santoso",
      role: "Concierge Manager",
      image: "/images/about/members/member-3.webp",
      bio: "Ready to assist residents' personal needs 24/7 with a warm smile.",
    },
    {
      id: 4,
      name: "Jessica Tan",
      role: "Community Manager",
      image: "/images/about/members/member-4.webp",
      bio: "Creating events and a warm community atmosphere among residents.",
    },
  ],
};

// Static images (no translation needed)
export const STORY_IMAGES = [
  "/images/about/storys/story-1.webp",
  "/images/about/storys/story-2.webp",
  "/images/about/storys/story-3.webp",
  "/images/about/storys/story-4.webp",
];

// Backward compatibility
export const ABOUT_HOME_DATA = aboutHomeDataByLang.id;
export const TEAM_MEMBERS = teamMembersByLang.id;

// i18n functions
export function getAboutHomeData(lang: Language = "id"): AboutHomeData {
  return aboutHomeDataByLang[lang] || aboutHomeDataByLang.id;
}

export function getTeamMembers(lang: Language = "id"): TeamMember[] {
  return teamMembersByLang[lang] || teamMembersByLang.id;
}
